import { createAction, union } from '@ngrx/store';
import { AvailableArea } from 'src/app/models/available-areas/available-area';
import { Coordinate } from 'src/app/models/coordinate/coordinate';
import { RestaurantKey } from 'src/app/models/restaurant/restaurant-key';
import { Restaurants } from 'src/app/models/restaurant/restaurants';
import { SearchAreaGroup } from 'src/app/models/search-area-group/search-area-group';
import { SearchAreas } from 'src/app/models/search-area/search-areas';
import { Time } from 'src/app/models/time/time';
import { RestoreSearchStateParams } from './restore-search-state-params';
import {
  CurrentPositionState,
  RestaurantsLoadingState,
} from './search.reducer';
import { ViewMode } from './view-mode';

export const updateRestaurantsLoadingState = createAction(
  'SearchActions updateLoadingState',
  (payload: RestaurantsLoadingState) => ({ payload }),
);

export const storeSearchAreaGroups = createAction(
  'SearchActions storeSearchAreaGroups',
  (payload: SearchAreaGroup[]) => ({ payload }),
);

export const storeSearchAreas = createAction(
  'SearchActions storeSearchAreas',
  (payload: { searchAreaGroupKey: string; searchAreas: SearchAreas }) => ({
    payload,
  }),
);

export const storeAvailableAreas = createAction(
  'SearchActions storeAvailableAreas',
  (payload: AvailableArea[]) => ({ payload }),
);

export const updateCurrentPositionState = createAction(
  'SearchActions updateCurrentPositionState',
  (payload: CurrentPositionState) => ({ payload }),
);

export const storeCurrentPosition = createAction(
  'SearchActions storeCurrentPosition',
  (payload: Coordinate) => ({ payload }),
);

export const storeCenterPosition = createAction(
  'SearchActions storeCenterPosition',
  (payload: Coordinate) => ({ payload }),
);

export const storeZoom = createAction(
  'SearchActions storeZoom',
  (payload: number) => ({ payload }),
);

export const storeSelectedSearchAreaGroupKey = createAction(
  'SearchActions storeSelectedSearchAreaGroupKey',
  (payload: string | null) => ({ payload }),
);

export const storeSelectedSearchAreakey = createAction(
  'SearchActions storeSelectedSearchAreakey',
  (payload: string | null) => ({ payload }),
);

export const storeSeats = createAction(
  'SearchActions storeSeats',
  (payload: number) => ({ payload }),
);

export const storeCurrentViewMode = createAction(
  'SearchActions storeCurrentViewMode',
  (payload: ViewMode) => ({ payload }),
);

export const storeRestaurants = createAction(
  'SearchActions storeRestaurants',
  (payload: Restaurants) => ({ payload }),
);

export const storeSelectedRestaurantKey = createAction(
  'SearchActions storeSelectedRestaurantKey',
  (payload: RestaurantKey) => ({ payload }),
);

export const restoreSearchState = createAction(
  'SearchActions restoreSearchState',
  (payload: RestoreSearchStateParams) => ({ payload }),
);

export const storeReservableTimes = createAction(
  'SearchActions storeReservableTimes',
  (payload: Time[]) => ({ payload }),
);

export const storeSelectedReservableTime = createAction(
  'SearchActions storeSelectedReservableTime',
  (payload: string) => ({ payload }),
);

export const showAreaSelectModal = createAction(
  'SearchActions showAreaSelectModal',
);

export const hideAreaSelectModal = createAction(
  'SearchActions hideAreaSelectModal',
  (payload: { searchAreaGroupKey: string }) => ({ payload }),
);

export const selectCurrentPositionInAreaSelectModal = createAction(
  'SearchActions selectCurrentPositionInAreaSelectModal',
);

export const selectSearchAreaInAreaSelectModal = createAction(
  'SearchActions selectSearchAreaInAreaSelectModal',
  (payload: { selectedSearchAreaKey: string }) => ({ payload }),
);

export const clearRestaurants = createAction('SearchActions clearRestaurants');

const all = union({
  updateRestaurantsLoadingState,
  storeSearchAreaGroups,
  storeSearchAreas,
  updateCurrentPositionState,
  storeCurrentPosition,
  storeCenterPosition,
  storeZoom,
  storeCurrentViewMode,
  storeSeats,
  storeRestaurants,
  storeSelectedRestaurantKey,
  clearRestaurants,
  restoreSearchState,
  storeReservableTimes,
  storeSelectedReservableTime,
  storeSelectedSearchAreaGroupKey,
  storeSelectedSearchAreakey,
  showAreaSelectModal,
  hideAreaSelectModal,
  selectCurrentPositionInAreaSelectModal,
  selectSearchAreaInAreaSelectModal,
});

export type SearchActionsUnion = typeof all;
